export const LOGIC_TEST_OPTION_VALUES = {
    A: 'A',
    B: 'B',
    C: 'C',
    D: 'D',
    E: 'E',
    F: 'F'
};
